import React, { useState, useEffect } from 'react';

import { JText as Text } from '@components/common/JText';
import { formatDateTime } from '@helper/formatTypes';
import { FONT_FAMILY_DEFAULT, FONT_SIZE_HEADER, FONT_WEIGHT_DEFAULT_HEADER } from '@assets/style/styleDefault';

const UseCurrentTime = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Text
      style={{
        color: '#939393',
        fontSize: FONT_FAMILY_DEFAULT,
        fontSize: FONT_SIZE_HEADER,
        fontWeight: FONT_WEIGHT_DEFAULT_HEADER,
      }}
    >
      {formatDateTime(currentTime)}
    </Text>
  );
};
export default UseCurrentTime;
